import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-partnership-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatDividerModule,
        MatSnackBarModule,
    ],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './partnership-dialog.component.html',
    styleUrl: './partnership-dialog.component.scss',
})
export class PartnershipDialogComponent {
    info: any;

    constructor(
        public dialogRef: MatDialogRef<PartnershipDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { partnership: any; source: string },
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        const partnership = this.data.partnership;
        if (this.data.source === 'digital-services') {
            this.info = {
                main_title: partnership.digPartnershipName,
                sub_title: partnership.digTitle,
                description: partnership.digDescription,
                partnershipImageUrl: partnership.partnershipImageUrl,
                partnershipUrl: partnership.partnershipUrl,
                cta: partnership.cta,
            };
        } else {
            this.info = {
                main_title: partnership.partnership,
                sub_title: partnership.partnershipDetails.partnershipName,
                description: partnership.partnershipDetails.longDesc,
                partnershipImageUrl:
                    partnership.partnershipDetails.partnershipImageUrl,
                partnershipUrl: partnership.partnershipUrl,
                cta: partnership.partnershipDetails.cta,
            };
        }
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        return value;
    }

    closeDialog() {
        this.dialogRef.close();
    }

    openURL(url: any) {
        if (
            url !== undefined ||
            url !== '' ||
            url !== null ||
            url !== 'undefined'
        ) {
            window.open(url, '_blank');
        } else {
            if (this.readLocalStorageValue('language') == 'bm') {
                this.toastr.warning('Sila nyatakan URL');
            } else {
                this.toastr.warning('Please define the url');
            }
        }
    }
}
